import React, { useState } from "react";
import "../styles/Header.css";
import wp from "../assets/mobil/wp.png";
import ins from "../assets/mobil/ins.png";
import mail from "../assets/mobil/mail.png";
import { useWebSocket } from "../hooks/useWebSocket";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { data: prices } = useWebSocket("wss://sslsocket.aifanet.com/5.250.255.84/12672");
  const [prevPrices, setPrevPrices] = useState<{ [code: string]: number }>({});
  const [priceDirections, setPriceDirections] = useState<{ [code: string]: "up" | "down" | null }>({});

  // Fiyatlar değiştiğinde yönleri ve önceki fiyatları güncelle
  React.useEffect(() => {
    const newDirections: { [code: string]: "up" | "down" | null } = {};
    const newPrevPrices: { [code: string]: number } = { ...prevPrices };
    prices.forEach((row) => {
      const prev = prevPrices[row.currencyPair];
      if (prev === undefined) {
        newDirections[row.currencyPair] = null;
      } else if (row.sellRate > prev) {
        newDirections[row.currencyPair] = "up";
      } else if (row.sellRate < prev) {
        newDirections[row.currencyPair] = "down";
      } else {
        newDirections[row.currencyPair] = null;
      }
      newPrevPrices[row.currencyPair] = row.sellRate;
    });
    setPriceDirections(newDirections);
    setPrevPrices(newPrevPrices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prices]);

  // % değişim hesapla
  const getChangePercent = (code: string, current: number) => {
    const prev = prevPrices[code];
    if (prev === undefined || prev === 0) return "0.00";
    const diff = ((current - prev) / prev) * 100;
    return diff.toFixed(2);
  };

  // Kayan yazı için fiyat bandı
  const renderTicker = () => (
    <div className="header-ticker-wrapper">
      <div className="header-ticker-track">
        {prices.map((row) => {
          const direction = priceDirections[row.currencyPair];
          const change = getChangePercent(row.currencyPair, row.sellRate);
          return (
            <div className={`header-ticker-item ${direction === "up" ? "ticker-up" : direction === "down" ? "ticker-down" : ""}`} key={row.currencyPair}>
              {direction === "up" && <span className="ticker-arrow">▲</span>}
              {direction === "down" && <span className="ticker-arrow">▼</span>}
              <span className="ticker-symbol">{row.currencyPair}</span>
              <span className="ticker-price">{row.sellRate.toLocaleString("tr-TR", { minimumFractionDigits: 4 })}</span>
              <span className="ticker-change">%{change}</span>
            </div>
          );
        })}
      </div>
    </div>
  );

  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className={`header custom-header-layout${menuOpen ? " expanded" : ""}`}>
      {renderTicker()}
      {/* Mobil Toggle */}
      <div className="mobile-toggle" onClick={handleToggle}>
        <span className="current-info">MENÜ</span>
        <span className="toggle-icon">&#9776;</span>
      </div>
      {/* Sosyal medya ve mail bölümleri kaldırıldı */}
    </div>
  );
};

export default Header;